/**
 * Zielgebiet: 2
 * Region: 5
 * Bundestaat: 6
 */

 (function ($) {
	$(function () {

		$('#filters input[type=checkbox]:checked').parent().addClass('active');

		$(document).on("click", "#filters input[type=checkbox]", function (e) {
        
			var form = $('form#filters');
		
			$(this).parent().toggleClass('active');
			var group_id = $(this).data('group');
			if( !($(this).hasClass('multi')) ) {
				if (this.checked) {
					$(this).closest('section').find('input[type=checkbox]').removeAttr('checked');
					this.checked = true;
				}
			}
			
			// logische Abhängigkeiten
			// Bsp: wenn das Zielgebiet entfernt wird
			// müssen auch Regionen und Bundesstaaten entfernt werden
			if( group_id == 2 ) {
				form.find('input[type=checkbox][data-group="5"]').removeAttr('checked');
				form.find('input[type=checkbox][data-group="6"]').removeAttr('checked');
			}
			if( group_id == 5 ) {
				form.find('input[type=checkbox][data-group="6"]').removeAttr('checked');
			}
			if( group_id == 1 ) {
				form.find('input[type=checkbox][data-group="7"]').removeAttr('checked');
			}
			var allPamams = $(form).serialize();
			var url = window.location.href.split('?')[0] + '?' + allPamams+'&paginate=1';
			var Filter = $("#FilterWrapper");
			$.ajax(url, {
				beforeSend: function (xhr) {
				  $('.loader').removeClass('hidden');
				}
			  })
				.done(function (response) {

					$('.results').html();
					$('.results').html(response);
					$('#resultCount').html($('#resultsection').data('cnt'));
					// Screenreader über aktualisierte Ergebnisse informieren
					var liveRegion = document.getElementById('a11y-filter-status');
					if (!liveRegion) {
						liveRegion = document.createElement('div');
						liveRegion.id = 'a11y-filter-status';
						liveRegion.setAttribute('role', 'status');
						liveRegion.setAttribute('aria-live', 'polite');
						liveRegion.className = 'visually-hidden';
						document.body.appendChild(liveRegion);
					}
					var cnt = $('#resultsection').data('cnt') || '';
					liveRegion.textContent = cnt + ' Ergebnisse gefunden';
					
					$('#filterscc input[type=checkbox]:checked').each(function( index ) {
						var filtercheckedValue = $(this).parent().parent().data('displayid');
						if(filtercheckedValue != 0){

							$('#filters .filtermerkmal').each(function(index){
								if($(this).data('displayid') !== filtercheckedValue){
								//	$(this).toggleClass('hidden');
								}
							})

						}
					});
					
					//$("#FilterWrapper #meinFilter").html($(response).find("#meinFilter"));
					/*
					$('#FilterWrapper').load(url+'&filtercheck=1 #meinFilter',function(){
						
						$( "#filters input" ).each(function( index ) {
						
							if($(this).is(':checked')){
								
								$(this).parent().css({'background':'green'});
								$(this).parent().addClass('active');
							}
						
						});

					});
					*/

					
					/*
					$.ajax({
						url:,
						success: function(response) {
						//  $("#ajaxContent").html(response);
						console.log($(response).find("#meinFilter"));
						$("#FilterWrapper #meinFilter").html($(response).find("#meinFilter"));
						}
					});
*/
				  //$('html, body').animate({
				  //	scrollTop: ($('.result-list ').offset().top -165)
				  //});
				  window.history.pushState(
					{url: url},
					document.title,
					url
				  );
				})
				.fail(function (xhr) {
				  console.error('Error: ' + xhr.responseText);
				})
				.always(function () {
				  $('.loader').addClass('hidden');
				});
			/*
			$.ajax({
				type: "GET",
				url: form.data('url'),
				data: form.serialize(),
				success: function(data) {
					console.log($('#resultsection').data('cnt'));
					
					$('.results').html();
					$('.results').html(data);
					$('#resultCount').html($('#resultsection').data('cnt'));
					window.history.pushState(
						{url: url},
						document.title,
						url
					  );
				}
			  });*/
			//form.submit();

		});

		var paginate = function (url) {
  
			$.ajax(url, {
			  beforeSend: function (xhr) {
				//loader zeigen ?
			  }
			})
			  .done(function (response) {
				  
				$('.results').append(response).fadeIn();
				 
				$('html, body').animate({
				  //scrolling oder so?
				});
				window.history.pushState(
				  {url: url},
				  document.title,
				  url
				);
			  })
			  .fail(function (xhr) {
				console.error('Error: ' + xhr.responseText);
			  })
			  .always(function () {
				//$('.loader').addClass('hidden');
			  })
			;
		  };
		
		  $('body').on('click', 'a.pager-next[href]', function (e) {
			e.preventDefault();
			//var filterSetID = $(this).closest('div[data-filterset]').attr('data-filterset');// falls benötigt
			// Prüfe, ob "paginate=1" schon vorhanden ist
			var href = $(this).attr('href');
			if (href.indexOf('paginate=1') === -1) {
				// Richtige Platzierung des Parameters je nachdem, ob schon andere vorhanden sind
				href += (href.indexOf('?') === -1 ? '?' : '&') + 'paginate=1';
			}

			paginate(href);
			$(this).parent().fadeOut('slow');
		  });
		
		
		  window.onpopstate = function (e) {
			if (e.state && e.state.url) {
			  paginate(e.state.url);
			} else {
			  e.preventDefault();
			}
		  };
	});
})(jQuery);

